// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/NumberFormat/NumberFormat

export type Currency = "EUR" | "CHF";

// Output: 100,00 €
const CurrencyFormatterWithEuroSign = new Intl.NumberFormat("de-DE", {
  style: "currency",
  currency: "EUR",
});

// Output: CHF 100.00
const CurrencyFormatterWithFrancSign = new Intl.NumberFormat("de-CH", {
  style: "currency",
  currency: "CHF",
});

const formatPriceWithCurrency = (currency: Currency, price = 0) => {
  if (currency === "EUR") {
    return CurrencyFormatterWithEuroSign.format(price);
  }
  return CurrencyFormatterWithFrancSign.format(price);
};

// eslint-disable-next-line import/prefer-default-export
export const FormatS = {
  formatPriceWithCurrency,
};
